import { ResizeObserver as ROPoylyfill } from '@juggle/resize-observer';

function addResizeObserver() {
  if (typeof window.ResizeObserver === 'undefined') {
    window.ResizeObserver = ROPoylyfill;
  }
}

export { addResizeObserver };
